export default __webpack_public_path__ + "img/1.05055f80.png";